import React, { Component } from "react";
import { Link } from "react-router-dom";

/* ============================================================
   LEVELUP ONE — Site footer
   ============================================================ */

const COLS = [
  {
    heading: "บริษัท",
    links: [
      { label: "เรื่องราว", to: "/story" },
      { label: "บริษัท", to: "/company" },
      { label: "ทีมงาน", to: "/teams" },
      { label: "วิสัยทัศน์", to: "/vision" },
      { label: "ร่วมงานกับเรา", to: "/career" },
    ],
  },
  {
    heading: "บริการ",
    links: [
      { label: "บริการทั้งหมด", to: "/services" },
      { label: "นวัตกรรม", to: "/innovation" },
      { label: "บทความ", to: "/blog" },
    ],
  },
  {
    heading: "เริ่มต้น",
    links: [
      { label: "จองคำปรึกษาฟรี", to: "/booking" },
      { label: "โซลูชันสำเร็จรูป", to: "/innovation" },
      { label: "บทความน่ารู้", to: "/blog" },
    ],
  },
];

export default class FooterComponent extends Component {
  render() {
    const year = new Date().getFullYear();
    return (
      <footer className="nx-footer">
        <div className="container">
          <div className="row g-4">
            <div className="col-12 col-lg-4">
              <div className="nx-footer__brand">
                <span className="nx-brand__mark">L</span> LevelUp One
              </div>
              <p className="nx-footer__about">
                เราสร้าง “พนักงาน AI” ที่ทำงานบนระบบเดิมของคุณ ทั้ง LINE, POS และ Excel
                ช่วยให้ธุรกิจ SME ทำงานเร็วขึ้นโดยไม่ต้องรื้อระบบ
              </p>
              <div className="nx-footer__social">
                <a href="https://line.me" title="LINE" aria-label="LINE">L</a>
                <a href="https://facebook.com" title="Facebook" aria-label="Facebook">f</a>
                <a href="https://instagram.com" title="Instagram" aria-label="Instagram">ig</a>
                <a href="mailto:info@levelupone.ai" title="Email" aria-label="Email">✉</a>
              </div>
            </div>

            {COLS.map((c) => (
              <div className="col-6 col-lg-2" key={c.heading}>
                <h6 className="nx-footer__heading">{c.heading}</h6>
                <ul className="nx-footer__list">
                  {c.links.map((l, i) => (
                    <li key={i}><Link to={l.to}>{l.label}</Link></li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="col-12 col-lg-2">
              <h6 className="nx-footer__heading">ติดต่อ</h6>
              <ul className="nx-footer__list">
                <li><a href="tel:+66931304223">+66 93 130 4223</a></li>
                <li><a href="mailto:info@levelupone.ai">info@levelupone.ai</a></li>
                <li>ระยอง, ประเทศไทย</li>
              </ul>
            </div>
          </div>

          <div className="nx-footer__bottom">
            <span>© {year} LevelUp One · ทำในไทย · ส่งทั่วโลก</span>
            <div style={{ display: "flex", gap: 18 }}>
              <Link to="/">นโยบายความเป็นส่วนตัว</Link>
              <Link to="/">เงื่อนไขการใช้งาน</Link>
              <Link to="/">คุกกี้</Link>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
